/**
 * Fichier de conf du catalogue : **uniquement des URLs**.
 *
 * Tout le reste (nom, logo, couleur, jeu rattaché) est déduit de l'API Olympe
 * au démarrage — cf. `api/olympe.ts` et `composables/useCompetition.ts`. Ajouter
 * une compétition = ajouter une ligne ici, rien d'autre à maintenir.
 *
 * L'hôte de l'URL sert de clé : il part en en-tête `X-Domain` et l'API le
 * compare *exactement* à ses domaines déclarés. Mettre celui qu'elle connaît :
 * 'www.playallforone.com' répond 200, la même URL sans le www répond 403.
 */
export const competitionUrls: string[] = [
  'https://www.playallforone.com/',
  'https://battlesquad.olympelegends.com/',
  'https://gloryus.olympelegends.com/',
  'https://moodpadel.olympelegends.com/',
  'https://splatoon-euro-leagues.olympelegends.com/',
  'https://olympe.dev.olympelegends.com/',
]
